import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const RequireAdmin = () => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500 dark:text-gray-400">
        Chargement…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2 text-center">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Accès refusé</h1>
        <p className="text-gray-500 dark:text-gray-400">
          Ce compte n'a pas les droits administrateur.
        </p>
      </div>
    );
  }

  return <Outlet />;
};

export default RequireAdmin;
